// extracted by mini-css-extract-plugin
module.exports = {"focus-div":"focusDiv_focus-div__1vqMu"};